import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	"aria-hidden": "true",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.7999 4.80005C4.16338 4.80005 3.55293 5.05291 3.10285 5.50299C2.65276 5.95308 2.3999 6.56353 2.3999 7.20005V8.40005H21.5999V7.20005C21.5999 6.56353 21.347 5.95308 20.897 5.50299C20.4469 5.05291 19.8364 4.80005 19.1999 4.80005H4.7999Z",
		fill: "#3F3F46"
	}), /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.5999 10.8H2.3999V16.8C2.3999 17.4366 2.65276 18.047 3.10285 18.4971C3.55293 18.9472 4.16338 19.2 4.7999 19.2H19.1999C19.8364 19.2 20.4469 18.9472 20.897 18.4971C21.347 18.047 21.5999 17.4366 21.5999 16.8V10.8ZM4.7999 15.6C4.7999 15.2818 4.92633 14.9766 5.15137 14.7515C5.37642 14.5265 5.68164 14.4 5.9999 14.4H7.1999C7.51816 14.4 7.82339 14.5265 8.04843 14.7515C8.27347 14.9766 8.3999 15.2818 8.3999 15.6C8.3999 15.9183 8.27347 16.2235 8.04843 16.4486C7.82339 16.6736 7.51816 16.8 7.1999 16.8H5.9999C5.68164 16.8 5.37642 16.6736 5.15137 16.4486C4.92633 16.2235 4.7999 15.9183 4.7999 15.6ZM10.7999 14.4C10.4816 14.4 10.1764 14.5265 9.95137 14.7515C9.72633 14.9766 9.5999 15.2818 9.5999 15.6C9.5999 15.9183 9.72633 16.2235 9.95137 16.4486C10.1764 16.6736 10.4816 16.8 10.7999 16.8H11.9999C12.3182 16.8 12.6234 16.6736 12.8484 16.4486C13.0735 16.2235 13.1999 15.9183 13.1999 15.6C13.1999 15.2818 13.0735 14.9766 12.8484 14.7515C12.6234 14.5265 12.3182 14.4 11.9999 14.4H10.7999Z",
		fill: "#3F3F46"
	})]
});
export default SvgCreditCard;
